import React from "react";
import {Col, Row} from "reactstrap";
import BrokerProfileForm from "../../../../components/brokerProfileForm";
import {useParams} from "react-router-dom";


export default function EditBroker() {
    const params = useParams();
    return <>
        <Row>
            <Col>
                <h3 className="page-header pb-2">Broker Information</h3>
            </Col>
        </Row>

        <BrokerProfileForm
            profileId={params.brokerId}
            isMe={false}/>
    </>
}